package uk.co.nickthecoder.kyd.shapes

import uk.co.nickthecoder.kyd.util.Vector2

/**
 * Note, unlike most drawing programs, a [Line] has a `fill` and a `stroke`.
 * The thickness of the `fill` is governed by [ShapeAppearance.lineWidth], and the thickness of the `stroke`
 * is governed by [ShapeAppearance.strokeWidth]. The latter is often zero (and therefore no `stroke` is used, just the `fill`).
 *
 * This allows us to draw a thick line with a thin stroke at its edges.
 */
class Line(points: Iterable<Vector2>) : SimpleShape(points) {

    fun close(): Polygon {
        return Polygon(points)
    }

    /**
     * We create a mesh (a set of triangles) for the line.
     * So far, we are doing a very simplistic algorithm, which will break under some circumstances.
     *
     *
     */
    override fun createFillMesh(shapeAppearance: ShapeAppearance): Mesh {
        return StrokeMesh().apply {
            insideThickness = shapeAppearance.lineWidth / 2
            outsideThickness = insideThickness
            capStyle = shapeAppearance.capStyle
            joinStyle = shapeAppearance.joinStyle
            includeStrokeGradient = shapeAppearance.fill.hasAcrossAttribute

        }.createStrokeMesh(points, isClosed = false)
    }

    override fun createStrokeMesh(shapeAppearance: ShapeAppearance): Mesh {

        val allPoints = ThickenLine().apply {
            insideThickness = shapeAppearance.lineWidth / 2
            outsideThickness = insideThickness
            capStyle = shapeAppearance.capStyle
            joinStyle = shapeAppearance.joinStyle
        }.thicken(points)

        return StrokeMesh().apply {
            insideThickness = shapeAppearance.strokeWidth * (1 - shapeAppearance.strokeRatio)
            outsideThickness = shapeAppearance.strokeWidth * shapeAppearance.strokeRatio
            joinStyle = JoinStyle.MITER
            capStyle = shapeAppearance.capStyle
            includeStrokeGradient = shapeAppearance.stroke.hasAcrossAttribute

        }.createStrokeMesh(allPoints, isClosed = true)
    }

}
